(() => {
  const selector = '[data-deferred-section-script]';
  const loadedScripts = new Map();
  const pendingSections = new Map();

  const loadScript = (src) => {
    if (loadedScripts.has(src)) return loadedScripts.get(src);

    const promise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.async = false;
      script.onload = resolve;
      script.onerror = () => reject(new Error(`Unable to load ${src}`));
      document.head.appendChild(script);
    });

    loadedScripts.set(src, promise);
    return promise;
  };

  const hydrateSection = (section) => {
    const markers = pendingSections.get(section) || [];
    pendingSections.delete(section);
    observer?.unobserve(section);

    markers.forEach((marker) => {
      if (marker.dataset.deferredSectionLoaded === 'true') return;
      marker.dataset.deferredSectionLoaded = 'true';
      loadScript(marker.dataset.deferredSectionScript).catch((error) => {
        marker.dataset.deferredSectionLoaded = 'false';
        console.error('[Dotfloor] Deferred section script failed', error);
      });
    });
  };

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) hydrateSection(entry.target);
          });
        },
        { rootMargin: '1000px 0px' }
      )
    : null;

  const registerMarker = (marker) => {
    if (marker.dataset.deferredSectionRegistered === 'true') return;
    marker.dataset.deferredSectionRegistered = 'true';

    const section = marker.closest('.shopify-section') || marker.parentElement;
    const markers = pendingSections.get(section) || [];
    markers.push(marker);
    pendingSections.set(section, markers);

    if (Shopify.designMode || !observer) {
      hydrateSection(section);
      return;
    }

    if (markers.length === 1) {
      observer.observe(section);
      section.addEventListener('focusin', () => hydrateSection(section), { once: true });
      section.addEventListener('pointerenter', () => hydrateSection(section), { once: true });
    }
  };

  const scan = (root = document) => root.querySelectorAll(selector).forEach(registerMarker);

  scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
